// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__38_XJ","header":"MergedInvoice_header__1r-i3"};